import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";

import { FronteraAuthProvider } from "@fronterahealth/frontera-auth0-react";

import "./index.css";

const getCookieDomainFromHostname = (
  hostname: string,
):
  | ".dev.fronterahealth.com"
  | ".staging.fronterahealth.com"
  | ".fronterahealth.com"
  | ".local.fronterahealth.com"
  | ".unknown-cookie.fronterahealth.com" => {
  switch (hostname) {
    case "signup.dev.fronterahealth.com":
      return ".dev.fronterahealth.com";
    case "signup.staging.fronterahealth.com":
      return ".staging.fronterahealth.com";
    case "signup.fronterahealth.com":
      return ".fronterahealth.com";
    case "localhost":
      return ".local.fronterahealth.com";
    default:
      console.error("Unexpected hostname, this should not happen");
      return ".unknown-cookie.fronterahealth.com";
  }
};

export const COOKIE_DOMAIN = getCookieDomainFromHostname(window.location.hostname);

const RedirectToHome = () => {
  useEffect(() => {
    const destinationUrl = window.localStorage.getItem("frontera_health__signup__destination_url");
    window.location.href = destinationUrl || import.meta.env.VITE_REDIRECT_URL;
  }, []);
  return null;
};

const getDestinationUrlFromURL = () => {
  const url = window.location.href;
  console.debug("<> getDestinationFromURL = ", new URL(url).search);
  const urlParams = new URLSearchParams(new URL(url).search);
  const destinationUrl = urlParams.get("destinationUrl") || import.meta.env.VITE_REDIRECT_URL;
  return destinationUrl;
};

// as long as the URL isn't coming from Auth0, then read the query params and set the correct value
if (!window.location.search.includes("code=")) {
  console.debug(`before setting a localStorage item (which will be ${getDestinationUrlFromURL()}`);
  window.localStorage.setItem("frontera_health__signup__destination_url", getDestinationUrlFromURL());
  console.debug("after setting a localStorage item");
  console.debug(
    `Local Storage (frontera_health__signup__destination_url) = ${localStorage.getItem("frontera_health__signup__destination_url")}`,
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <FronteraAuthProvider
      loginOnMount={true}
      cookieDomain={COOKIE_DOMAIN}
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      audience={import.meta.env.VITE_AUTH0_AUDIENCE}
      authorizationParams={{
        screen_hint: "signup",
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={(appState) => {
        const destinationUrl = window.localStorage.getItem("frontera_health__signup__destination_url");
        console.debug("<> onRedirectCallback (inside Website)", {
          appState,
          destinationUrl,
          viteRedirectUrl: import.meta.env.VITE_REDIRECT_URL,
        });
        window.location.href = destinationUrl || import.meta.env.VITE_REDIRECT_URL;
      }}
    >
      {/* NOTE: This should never really get hit upon the users first time account registration + login because
      the above `onRedirectCallback` will get called and will punt the user over to the VITE_REDIRECT_URL value

      If the user decides to instead directly navigate to signup.fronterahealth.com while logged in (most users shouldn't do this because this is weird),
      we will simply redirect them to VITE_REDIRECT_URL
        */}
      <RedirectToHome />
    </FronteraAuthProvider>
  </React.StrictMode>,
);
